module.exports = __webpack_public_path__ + "static/media/mobile834.fa8f2e23.png";